module.exports = __webpack_public_path__ + "img/msff-info.62560366.svg";